import React, { Component } from 'react';
import { Paper, Button, InputLabel, FormControl } from '@material-ui/core';

import { withTheme } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import Datetime from 'react-datetime';
import GridItem from '../Grid/GridItem.jsx';
import GridContainer from '../Grid/GridContainer.jsx';
import { CodeSharp } from '@material-ui/icons';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
class DateTimePanel extends Component {
    constructor() {
        super();
    }

    // handleChange = name => event => {
    //     this.setState({ [name]: event.target.checked });
    // };

    render() {
        const { userData } = this.props;

        return (
            <div className="container1">
                <div className="main-panel">
                    <FormControl fullWidth>
                        <Datetime
                            dateFormat={
                                this.props.dateFormat
                                    ? this.props.dateFormat
                                    : true
                            }
                            placeholder="Established Date"
                            open={this.props.open}
                            isValidDate={this.props.isValidDate}
                            timeFormat={this.props.timeFormat}
                            viewDate={this.props.value}
                            color="primary"
                            inputProps={{
                                placeholder: 'Click here to choose'
                            }}
                            value={this.props.value}
                            onChange={this.props.onChange}
                            defaultValue={this.props.defaultValue}
                        />
                    </FormControl>
                </div>
            </div>
        );
    }
}
export default withTheme()(withUser(DateTimePanel));



// WEBPACK FOOTER //
// ./src/components/Providers/DateTimePanel.jsx